/**
 * This file was auto-generated by Fern from our API Definition.
 */
export const JobMode = {
    Foreground: "foreground",
    Background: "background",
    ToolbarBlocking: "toolbarBlocking",
    Hidden: "hidden",
};
